export default {
  title: "Support",
  rules: {
    note: "Before submitting a request, please read the rules:",
    rule_1: "1. First, review our {faq} (FAQ) section — your answer may already be there.",
    rule_2: "2. If you have payment issues, be sure to include transaction details (date, amount, payment method, screenshots).",
    rule_3: "3. If you have problems downloading files, be sure to include the links to those files.",
    rule_4: "4. For copyright issues or any other files that violate the rules, contact: {email}",
    rule_5: "5. For cooperation, affiliate programs, advertising, and other business inquiries, contact: {email}",
    rule_6: "6. A response may take from 12 hours up to 2 business days, depending on the complexity of the request and support workload.",
    rules: "rules",
    faq: "frequently asked questions"
  },
  messages: {
    note: "*Showing the last {count} messages",
    you: "You",
    support: "Support",
    autoanswer_subject_is_over: "The conversation has been closed as your issue has been resolved.\nThank you for contacting support."
  },
  inputs: {
    message: {
      placeholder: "Write your question"
    },
    attachments: {
      btn: "{text} {formats}",
      attach_file: "Attach file",
      attached_files: "Attached files:"
    }
  },
  errors: {
    generic: "Error",
    invalid_file_type: "Unsupported file format.",
    max_file_size_limit: "File is too large. Choose a smaller file.",
    filename_too_long: "Filename is too long",
    filename_invalid_chars: "Filename contains invalid characters"
  },
  btn: {
    send: "Send"
  }
};
